export default "__VITE_ASSET__DsiZF1Hl__"